unit FileType;
{

/* Initail. */

}
interface

uses
  JS,
  TypeType;

type
  TFileType = class
  private
    fFileKey: String;
    fName: String;
    fExtension: String;
    fPath: String;
    fType: TTypeType;
    fActive: Boolean;
  public
    property FileKey: String read fFileKey;
    property Name: String read fName;
    property Extension: String read fExtension;
    property Path: String read fPath;
    property FileType: TTypeType read fType;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TFileType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fFileKey := String(JSObject_Type['fileKey']);
    fName := String(JSObject_Type['name']);
    fExtension := String(JSObject_Type['extension']);
    fPath := String(JSObject_Type['path']);
    fType := TTypeType.Create(TJSJSON.stringify(JSObject_Type['name']));
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
